import {
	Toast,
	ToastClose,
	ToastDescription,
	ToastProvider,
	ToastTitle,
	ToastViewport,
} from '@/components/ui/toast';
import { useToast } from '@/components/ui/use-toast';
import React from 'react';
import { CheckCircle2, XCircle, AlertCircle, Info, Loader2 } from 'lucide-react';

export function Toaster() {
	const { toasts } = useToast();
	const activeCount = toasts.length;

	return (
		<ToastProvider>
			{/* We only render the LATEST toast (Singularity Mode) */}
			{toasts.length > 0 && (() => {
				const { id, title, description, action, variant, ...props } = toasts[0];
				return (
					<Toast key={id} variant={variant} {...props}>
						<div className="flex items-start gap-4 relative">
							{/* The Status Icon with Pulse Badge for Batching */}
							<div className="relative mt-1">
								{variant === 'success' && <CheckCircle2 className="h-5 w-5 text-emerald-400" />}
								{variant === 'destructive' && <XCircle className="h-5 w-5 text-rose-400" />}
								{variant === 'warning' && <AlertCircle className="h-5 w-5 text-amber-400" />}
								{(!variant || variant === 'default') && (
									title?.toLowerCase().includes("processing") || title?.toLowerCase().includes("generating") 
										? <Loader2 className="h-5 w-5 text-blue-400 animate-spin" />
										: <Info className="h-5 w-5 text-blue-400" />
								)}

								{/* Multi-Action Pulse Badge */}
								{activeCount > 1 && (
									<div className="absolute -top-2 -right-2 flex h-4 w-4 items-center justify-center rounded-full bg-slate-900 text-[10px] font-black text-white ring-2 ring-slate-800 animate-pulse shadow-lg">
										{activeCount}
									</div>
								)}
							</div>

							<div className="grid gap-1">
								<div className="flex items-center gap-2">
									{title && <ToastTitle>{title}</ToastTitle>}
									{activeCount > 1 && (
										<span className="text-[9px] font-black uppercase tracking-tighter text-blue-400/60 bg-blue-400/5 px-1.5 py-0.5 rounded-md">
											+ {activeCount - 1} ACTIVE
										</span>
									)}
								</div>
								{description && (
									<ToastDescription>{description}</ToastDescription>
								)}
							</div>
						</div>
						{action}
						<ToastClose />
					</Toast>
				);
			})()}
			<ToastViewport />
		</ToastProvider>
	);
}